// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/button/button.component.scss
// module id = 159
// module chunks = 0